import React from 'react';
import { ILocaleConfig } from '@interfaces';

export const DE_DOMAIN = 'dreamlines.de' as const;
export const NL_DOMAIN = 'dreamlines.nl' as const;
export const CRUISE_AWAY_DOMAIN = 'cruiseaway.com.au' as const;
export const C1AU_DOMAIN = 'cruise1st.com.au' as const;
export const C1UK_DOMAIN = 'cruise1st.co.uk' as const;

type DreamlinesDomains =
    | typeof DE_DOMAIN
    | typeof NL_DOMAIN
    | typeof CRUISE_AWAY_DOMAIN
    | typeof C1AU_DOMAIN
    | typeof C1UK_DOMAIN;

interface ILocaleConfigContext extends ILocaleConfig {
    marketMap: {
        isDreamlinesDE: boolean;
        isDreamlinesNL: boolean;
        isCruiseAway: boolean;
        isCruise1stAU: boolean;
        isCruise1stUK: boolean;
    };
    domainMap: {
        [key: string]: DreamlinesDomains;
    };
}

export const LocaleConfigContext = React.createContext<ILocaleConfigContext>({} as any);

interface ILocaleConfigProvider {
    config: ILocaleConfig;
    children: React.ReactNode;
}

const getMarketMap = (url: string) => ({
    isDreamlinesDE: url === DE_DOMAIN,
    isDreamlinesNL: url === NL_DOMAIN,
    isCruiseAway: url === CRUISE_AWAY_DOMAIN,
    isCruise1stAU: url === C1AU_DOMAIN,
    isCruise1stUK: url === C1UK_DOMAIN,
});

export const LocaleConfigProvider = ({ children, config }: ILocaleConfigProvider) => {
    return (
        <LocaleConfigContext.Provider
            value={{
                ...config,
                marketMap: getMarketMap(config.url),
                domainMap: {
                    DE_DOMAIN,
                    NL_DOMAIN,
                    CRUISE_AWAY_DOMAIN,
                    C1AU_DOMAIN,
                    C1UK_DOMAIN,
                },
            }}
        >
            {children}
        </LocaleConfigContext.Provider>
    );
};
